/*!
 * Mobile Genome (Development Release)
 * Copyright 2014 NogginLabs, Inc.
 * Authored by: NogginLabs Programming Team
 */

define('screens/overlays/scenario-overlay',['require','underscore','jquery','core/overlay-screen','core/engine'],function(require) {
  'use strict';

  /////////////
  // IMPORTS /{
  /////////////

  var _ = require('underscore');
  var $ = require('jquery');
  var OverlayScreen = require('core/overlay-screen');
  var Engine = require('core/engine');

  /*****************************************************************************************************************///}

  var ScenarioOverlay = OverlayScreen.extend({

    events: {
      'click .tab-bar .tab': 'onTabClickHandler',
      'click .faq-btn': 'onFAQClickHandler',
      'click .tutorial-topic': 'onTopicClickHandler',
      'click .slider-prev': 'onPrevClickHandler',
      'click .slider-next': 'onNextClickHandler',
      'click .resource-link': 'onResourceClickHandler',
      'click .slider-done': 'onSliderDoneClickHandler'
    },
    displayType: 'menu', //menu, mission
    activeTab: 'tutorial', //tutorial, faq, resources
    activeTopic: 'mission',
    activeIndex: 0,
    faqIndex: 0,
    sliderPanels: {},
    activeTutorials: {},

  /////////////
  // METHODS /{
  /////////////

    initialize: function(options)
    {
      OverlayScreen.prototype.initialize.apply(this, arguments);
      this.displayType = Engine.module('Paging').currentPage.get('id') === 'menu' ? 'menu' : 'mission';
      this.topicFilters = Engine.module('Paging').currentPage.get('data').get('helpTopics');

      //if (this.displayType === 'mission' && this.topicFilters)
      this.activeTopic = 'mission';
      this.filterDisplay();
      //else
      //this.model.set('activeTutorials', this.model.get('tutorials'));
    },

    onRender: function()
    {
      //console.log('render help');
      this.$el.attr('data-type', this.displayType);
      this.updateDisplay(true);
      this.updateSliderPanel(this.$el.find('.carousel-container, .single-container'));
      if (this.displayType === 'mission')
        this.$el.find('.mission-bar h1').html(Engine.module('Paging').currentPage.collection.parent.get('title'));
    },

    onShow: function()
    {
      this.finish();
      console.log('engine', Engine.module('Paging').currentPage);
    },

    onTabClickHandler: function(evt)
    {
      var newPanel = $(evt.currentTarget).attr('data-panel');
      if (newPanel !== this.activeTab)
      {
        this.activeTab = newPanel;
        this.updateDisplay();
      }
    },

    onFAQClickHandler: function(evt)
    {
      var faqItem = $(evt.currentTarget);
      var faqBox = faqItem.parent();

      if (faqBox.attr('data-toggle') === 'closed')
        faqBox.attr('data-toggle', 'open');
      else
        faqBox.attr('data-toggle', 'closed');
    },

    onSliderDoneClickHandler: function(evt)
    {
      if ($(evt.currentTarget).hasClass('disabled'))
        return;

      this.closeOverlay();
    },

    filterDisplay: function()
    {
      var self = this;
      var lastTut = null;

      this.activeTutorials = {};
      this.sliderPanels = {};
      this.activeIndex = 0;

      _.each(this.model.get('tutorials'), function(tut, index) {
        if (!self.topicFilters || self.topicFilters.indexOf(tut.id) >= 0)
        {
          self.activeTutorials[tut.id] = tut;
          lastTut = tut;
          tut.activeIndex = index;
          /*if (tut.panels.length > 1)
            self.setupPanelSlider(tut);*/
          self.setupPanelSlider(tut);

          if (index === 0)
            tut.isFirst = true;

          _.each(tut.panels, function(panel) {
            if (panel.scenarioBG)
            {
              //console.log('add bg', Engine.module('Paging').firstModule());
              if (self.displayType === 'mission')
                tut.bgGraphic = 'content/graphics/mission_scene_' + Engine.module('Paging').currentPage.collection.parent.get('id') + '.png';
              else
                tut.bgGraphic = 'content/graphics/mission_scene_' + Engine.module('Paging').firstModule().get('id') + '.png';
            }
          });
        }
      });

      if (lastTut)
        lastTut.isLast = true;

      //this.activeTutorials.mission.panels[0].graphic = ;
      this.model.set('activeTutorials', this.activeTutorials);
    },

    setActiveIndexByTopic: function(topic)
    {
      var aIndex;
      _.each(this.activeTutorials, function(tut) {
        if (tut.id === topic)
        {
          aIndex = tut.activeIndex;
          tut.index = 0;
          return false;
        }
      });

      var $cPanel = this.$el.find('[data-id=topic-' + topic + '].carousel-container, [data-id=topic-' + topic + '].single-container');
      this.updateSliderPanel($cPanel);
      this.activeIndex = aIndex;
      this.updateTutorial(false, topic);
    },

    setTopicByActiveIndex: function(index)
    {
      var topic;
      _.each(this.activeTutorials, function(tut) {
        console.log('active', tut);
        if (tut.activeIndex === index)
        {
          topic = tut.id;
          tut.index = 0;
          return false;
        }
      });

      var $cPanel = this.$el.find('[data-id=topic-' + topic + '].carousel-container, [data-id=topic-' + topic + '].single-container');
      this.updateSliderPanel($cPanel);
      this.updateTutorial(false, topic);
    },

    setupPanelSlider: function(tut)
    {
      tut.index = 0;
      tut.max = tut.panels.length;
      this.sliderPanels[tut.id] = tut;
    },

    updateSliderPanel: function(__panels, __index)
    {
      __index = __index === undefined ? 0 : __index;
      if (__panels)
      {
        var self = this;
        _.each(__panels.get(), function(panel) {
          var __panel = $(panel);
          //console.log(__panel.attr('data-id'), this.sliderPanels);
          var $tut = self.sliderPanels[__panel.attr('data-id').replace('topic-', '')];
          __panel.find('.carousel-panel').removeClass('active');
          __panel.find('.slider-dot').removeClass('active');

          __panel.find('[data-index="' + __index + '"].slider-dot').addClass('active');
          __panel.find('[data-index="' + __index + '"].carousel-panel').addClass('active');

          var __maxIndex = __panel.attr('data-length') - 1;
          __panel.find('.btn-box').removeClass('disabled');
          __panel.find('.slider-done').addClass('disabled');

          if (__index === 0 && $tut.isFirst)
            __panel.find('.slider-prev').addClass('disabled');

          if (__index === __maxIndex && $tut.isLast)
          {
            __panel.find('.slider-done').removeClass('disabled');
            __panel.find('.slider-next').addClass('disabled');
          }
        });
      }
    },

    onPrevClickHandler: function(evt)
    {
      var $btn = $(evt.currentTarget);
      var $topicID = $btn.attr('data-id');
      var $cPanel = this.$el.find('[data-id=topic-' + $topicID + '].carousel-container, [data-id=topic-' + $topicID + '].single-container');
      var $tut = this.sliderPanels[$topicID];

      if ($tut.index > 0)
      {
        $tut.index--;
        this.updateSliderPanel($cPanel, $tut.index);
      }
      else if (!$tut.isFirst)
      {
        this.activeIndex--;
        this.setTopicByActiveIndex(this.activeIndex);
      }
    },

    onNextClickHandler: function(evt)
    {
      var $btn = $(evt.currentTarget);
      var $topicID = $btn.attr('data-id');
      var $cPanel = this.$el.find('[data-id=topic-' + $topicID + '].carousel-container, [data-id=topic-' + $topicID + '].single-container');
      var $tut = this.sliderPanels[$topicID];

      console.log('next click', $tut);
      if ($tut.index < $tut.max - 1)
      {
        $tut.index++;
        this.updateSliderPanel($cPanel, $tut.index);
      }
      else if (!$tut.isLast)
      {
        this.activeIndex++;
        this.setTopicByActiveIndex(this.activeIndex);
      }
    },

    onResourceClickHandler: function(evt)
    {
      var $btn = $(evt.currentTarget);
      var $link = $btn.attr('data-link');
      window.open($link, 'resource_window');
    },

    updateDisplay: function(__first)
    {
      __first = (__first === undefined) ? false : __first;

      this.$el.find('.scenario-panel').hide();
      this.$el.find('#panel-' + this.activeTab).show();

      this.$el.find('.tab-bar .tab').removeClass('active');
      this.$el.find('[data-panel=' +  this.activeTab + ']').addClass('active');

      if (this.activeTab === 'tutorial')
        this.updateTutorial(__first);
    },

    onTopicClickHandler: function(evt)
    {
      var $topic = $(evt.currentTarget).attr('data-id').replace('topic-', '');
      this.setActiveIndexByTopic($topic);
      //this.updateTutorial(false, $topic);
    },

    updateTutorial: function(__first, __topic)
    {
      var tutorialTopic = __topic === undefined ? this.activeTopic : __topic;
      var activeActivity = Engine.viewport.pageHolder.currentView.activeLocation;
      var activityType = activeActivity ? activeActivity.activityType.toLowerCase() : null;

      if (activeActivity && __first && activityType.indexOf('animation') === -1)
      {
        tutorialTopic = activityType.replace('activity_', '');
      }

      this.$el.find('.tutorial-topic').removeClass('active');
      this.$el.find('[data-id=topic-' + tutorialTopic + '].tutorial-topic').addClass('active');

      this.$el.find('.content-container .tutorial-container').hide();
      this.$el.find('.content-container [data-id=topic-' + tutorialTopic + '].tutorial-container').show();

      this.activeTopic = tutorialTopic;
      //console.log('update tutorial tab: ', tutorialTopic);
    },

    customDestroy: function()
    {
      this.radio.trigger('scenario.overlay.closing');
    }
  /*****************************************************************************************************************///}

  });

  return ScenarioOverlay;

});

